(async () => {

  if (!customElements.get('legal-popup')) {

    const { Fancybox } = await import('@fancyapps/ui');
    const { default: Cookies } = await import('js-cookie');

    class LegalPopup extends HTMLElement {

      constructor() {
        super();

        // Scope
        const self = this;
        // Scope elements
        self.LegalPopupWrapper = self.querySelector('[data-legal-popup-wrapper]');
        self.LegalPopupWrapper.classList.add('hidden');

        // set legal popup cookie identifier
        self.LegalPopupCookieIdentifier = "legal_popup";

        // Default options
        self.defaultOptions = {
          expiresInDays: 0,
        };

        self.dataOptions = {};

        // Get options from element data and combine with default options
        if (self?.dataset.options) {
          self.dataOptions = JSON.parse(self.dataset.options);
        }

        self.options = {
          ...self.defaultOptions,
          ...self.dataOptions
        };

        self.init();


        // Listen to extra events when in Shopify editor
        if (Shopify.designMode) {

          // Update when the section event is triggerd
          window.addEventListener('shopify:section:load', (event) => {
            if (event.detail.sectionId == "legal-popup") {
              //Fancybox.close();
              //self.init();
              self.LegalPopupWrapper.classList.remove('hidden');

            }
          });
        }
      }

      /**
       * Init the legal popup plugin
       * @returns void
       */
      init() {
        // Scope
        const self = this;

        // if legal popup days is set to zero, remove cookie if exists
        if (parseInt(self.options.expiresInDays) == 0) {
          Cookies.remove(self.LegalPopupCookieIdentifier);
        }

        // Get and scope legal popup cookie
        self.LegalPopupCookie = Cookies.get(self.LegalPopupCookieIdentifier);
        if (typeof self.LegalPopupCookie == 'undefined') {
          self.LegalPopupCookie = 'true';
        }
        self.LegalPopupCookie = (self.LegalPopupCookie === 'true');

        // Render legal popup if given
        if (!self.mayRenderLegalPopup()) {
          return true;
        }

        // render the legal popup
        self.renderLegalPopup();
      }

      /**
       * Check if the legal popup may be rendered and that there is a message to show
       * @returns boolean
       */
      mayRenderLegalPopup() {
        // Scope
        const self = this;

        // guard: check if popup cookie is set
        if (!self.LegalPopupCookie) {
          self.LegalPopupWrapper.classList.add('hidden');
          return false;
        }
        self.LegalPopupWrapper.classList.remove('hidden');
        return true;
      }

      /**
       * Render the legal popup
       * @returns void
       */
      renderLegalPopup() {
        // Scope
        const self = this;

        // Open fancybox and set callback for destroy event
        Fancybox.show(
          [
            {
              src: self.LegalPopupWrapper,
              type: "html",
            },
          ],
          {
            mainClass: 'fancybox--is-legal-popup',
            on: {
              destroy: () => {
                self.closeLegalPopup();
              }
            }
          }
        );

        // set enable cookie
        Cookies.set(self.LegalPopupCookieIdentifier, true, {
          expires: self.options.expiresInDays
        });
      }

      /**
       * Close legal popup
       * @returns void
       */
      closeLegalPopup() {
        // Scope
        const self = this;

        Cookies.set(self.LegalPopupCookieIdentifier, false, {
          expires: self.options.expiresInDays
        });

        Fancybox.close();
      }
    }

    window.LegalPopup = LegalPopup;
    customElements.define('legal-popup', LegalPopup);
  }
})();
